// export class PostSevaBooking {
//     phone : number;
//     name : string;
//     gotra : string;
//     nakshatra : number;
//     date: string;
//     numpersons:number;
//     amountpaid:number;
//     amountpending: number;
//     amounttotal:number;
//     paymenttype:string;
//     paymentnote:string;
//     special_request:string;
//     other_charges:number;
//     reporting_time:string;
//     token_details:string;
//     bookingtype:string;
//     seva: SelectedSeva[];

//     PostSevaBooking(){
//         this.bookingtype = "C";
//         this.other_charges = 0.0;
//         this.seva = [];
//     }
// }

// class SelectedSeva {
//     id: number;
//     quantity: number;
// }

import { SevalistforBooking } from '../models/SevalistforBooking';


export class PostSevaBooking {
    phone : number;
    name : string;
    gotra : string;
    emailid : string;
    nakshatra : number;
    date: string;
    numpersons:number;
    amountpaid:number;
    amountpending: number;
    amounttotal:number;
    paymenttype:number;
    paymentnote:string;
    specialrequest:string;
    other_charges:number;
    reporting_time:string;
    tokendetails:string;
    bookingtype:string;
    seva: SevalistforBooking[];
    seva_time:any;
    veda: string;
    //id?:any;
    // PostSevaBooking(){
    //     this.bookingtype = "C";
    //     this.other_charges = 0.0;
    //     this.seva = [];
    // }
}



// WEBPACK FOOTER //
// ./src/models/PostSevaBooking.ts